// src/App.jsx
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./adminProtect";

import Home from "./components/LandingPage";
import NotFound from "./components/NotFound";
import { AuthPage } from "./components/AuthPage";
import ProtectedRoute from "./pages/ProtectedRoute";
import { AuthProvider } from "./context/authContext";
import DefaultLayout from "./components/Dashboard/Layout/DefaultLayout";
import DashboardHome from "./components/Dashboard/Pages/Home/DashboardHome";
import DashboardQR from "./components/Dashboard/Pages/QR/DashboardQR";
import DashboardFeedback from "./components/Dashboard/Pages/Feedback/DashboardFeedback";
import DashboardReward from "./components/Dashboard/Pages/Reward/DashboardReward";
import DashboardReport from "./components/Dashboard/Pages/Report/DashboardReport";
import ForgetPassword from "./components/AuthPage/ForgetPassword";
import ResetPassword from "./components/AuthPage/ResetPassword";
import AboPage from "./components/Dashboard/Pages/Abo";
import SuccessPage from "./components/Dashboard/Pages/Abo/Sucess";
import CancelPage from "./components/Dashboard/Pages/Abo/Cancel";
import EmailVerification from "./components/AuthPage/EmailVerification";
import DashboardSettings from "./components/Dashboard/Pages/Settings/DashboardSettings";
import DashboardProfile from "./components/Dashboard/Pages/Profile/DashboardProfile";
import FeedbackFormPage from "./components/FeedbackForm/FeedbackFormPage";
import VerifyNewEmail from "./components/AuthPage/VerifyNewMail";
import NotificationPage from "./components/Dashboard/Pages/Notifications/NotificationPage";
import AdminHome from "./components/AdminDashboard/Pages/Home/AdminHome";
import AdminDefaultLayout from "./components/AdminDashboard/Layout/DefaultLayout";
import AdminUserList from "./components/AdminDashboard/Pages/User/AdminUser";
import AboManagement from "./components/Dashboard/Pages/AboManagement/AboManagement";
import PrivacyPolicy from "./components/Policy/PrivacyPolcy";
import Impressum from "./components/Policy/Impressum";
import Cookies from "./components/Policy/Cookies";
import AdminNotifications from "./components/AdminDashboard/Pages/AdminNotifications/AdminNotifications";
import SupportTickets from "./components/AdminDashboard/Pages/Support/SupportTickets";
import SystemSettings from "./components/AdminDashboard/Pages/SystemSettings/SystemSettings";
import SupportTicketForm from "./components/Dashboard/Pages/Support/Support";
import Tutorials from "./components/Dashboard/Pages/Tutorials/Tutorials";
import AllFeedbackPage from "./components/Dashboard/Pages/AllFeedbacks/AllFeedbacks";
import AGBs from "./components/Policy/AGBs";
import BlogPage from "./components/Blog/Blog";

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => {
    return localStorage.getItem("isAdminAuthenticated") === "true";
  });

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/login"
            element={
              isAdminAuthenticated ? (
                <AuthPage />
              ) : (
                <AdminLogin
                  onSuccess={() => {
                    localStorage.setItem("isAdminAuthenticated", "true");
                    setIsAdminAuthenticated(true);
                  }}
                />
              )
            }
          />

          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email/:token" element={<EmailVerification />} />
          <Route path="/feedbackform/:id" element={<FeedbackFormPage />} />
          <Route path="/verify-new-email/:token" element={<VerifyNewEmail />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/agbs" element={<AGBs />} />
          <Route path="/blog" element={<BlogPage />} />

          {/* Geschützte Routen */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DefaultLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="qr-management" element={<DashboardQR />} />
            <Route path="feedback-management" element={<DashboardFeedback />} />
            <Route path="voucher-management" element={<DashboardReward />} />
            <Route path="reports-analytics" element={<DashboardReport />} />
            <Route path="settings" element={<DashboardSettings />} />
            <Route path="profile" element={<DashboardProfile />} />
            <Route path="notifications" element={<NotificationPage />} />
            <Route path="abomanagement" element={<AboManagement />} />
            <Route path="support" element={<SupportTicketForm />} />
            <Route path="tutorials" element={<Tutorials />} />
            <Route path="allfeedback" element={<AllFeedbackPage />} />
          </Route>

          {/* Geschützte Routen ADMIN */}
          <Route
            path="/admindashboard"
            element={
              <ProtectedRoute>
                <AdminDefaultLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminHome />} />
            <Route path="user" element={<AdminUserList />} />
            <Route path="support" element={<SupportTickets />} />
            <Route path="systemsettings" element={<SystemSettings />} />
            <Route path="adminnotifications" element={<AdminNotifications />} />
          </Route>

          {/* Abo-Seiten ohne Abo-Check */}
          <Route
            path="dashboard/abo"
            element={
              <ProtectedRoute subscriptionRequired={false}>
                <AboPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/abo/success/:token"
            element={
              <ProtectedRoute subscriptionRequired={false}>
                <SuccessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/abo/cancel"
            element={
              <ProtectedRoute subscriptionRequired={false}>
                <CancelPage />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
